export const createResourceUrl = (uri, container, name = undefined) => {
  const urlParams = uri.slice(Math.max(uri.indexOf('?'), 0))
  const url = new URL(`${container}/${name}${urlParams}`, uri)
  return url
}

export const blobSegmentsFromUrl = (url, location) => {
  const pathname = (url instanceof URL) ? decodeURI(url.pathname) : decodeURI(new URL(decodeURI(url)).pathname)
  const blobName = pathname.replace(/^\//, '').split('/').slice(1).join('/')
  return blobName.substring(location.length + 1).split('/')
}

export const sasNeedsRefresh = uri => {
  if (!uri) return true
  const url = new URL(uri)
  const exp = url.searchParams.get('se')
  const minDelta = 30 * 1000
  return (exp)
    ? (new Date(exp) - Date.now() < minDelta)
    : true
}
